import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "45e402d6-e67d-420d-8c2a-35b44098636c",
    content: "Auralizations based on simulations mostly<br>lead to authentic results.",
    options: {},
  },
  {
    id: "c5d8e8a7-180e-4525-8053-0ab0bb8c5644",
    content: "A common method for validation is to compare<br>measured sounds with simulated sounds.",
    options: {},
  },
  {
    id: "3bd3d985-6524-4fe1-8132-dc281668b586",
    content:
      "If simulations provide accurate acoustical parameters,<br>the corresponding auralization can be considered as authentic.",
    options: {},
  },
];

export const task: Task = {
  id: "8437fb22-0011-40ac-82b8-faeeeb39bbf7",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c5d8e8a7-180e-4525-8053-0ab0bb8c5644"],
};
